var _rect, _rect2, _text, _line, _text2, _text3, _text4, _text5, _text6, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDishDataOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 130,
    viewBox: "0 0 180 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 130,
    rx: 14,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 130,
    rx: 14,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 26,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, "DISH DATA")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 38,
    x2: 164,
    y2: 38,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 60,
    fill: "rgba(0, 0, 0, 0.6)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 500
  }, "Prep Time:")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 60,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    textAnchor: "end"
  }, "15 mins")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 84,
    fill: "rgba(0, 0, 0, 0.6)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 500
  }, "Cook Time:")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 84,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    textAnchor: "end"
  }, "10 mins")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 108,
    fill: "rgba(0, 0, 0, 0.6)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 500
  }, "Difficulty:")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 108,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    textAnchor: "end"
  }, "Intermediate")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishDataOverlay);
export default __webpack_public_path__ + "static/media/dish-data-overlay.95f424e7827e36fa2f85ce9ac10db92b.svg";
export { ForwardRef as ReactComponent };